import { Injectable } from '@angular/core';
import { Api } from '../shared/api';
import {
  OcpiPartner,
  CreateOcpiPartnerRequest,
  UpdateOcpiPartnerRequest,
} from '../models/ocpi-partner.model';
import { JsonSerializer } from 'typescript-json-serializer';
import { Globals } from '../shared/globals';

@Injectable()
export class OcpiPartnerService {
  private jsonSerializer = new JsonSerializer();

  private partnersUrl = this.globals.adminUrl('ocpi-partners');

  constructor(private readonly globals: Globals, private readonly api: Api) {}

  async getOcpiPartners(): Promise<Array<OcpiPartner>> {
    const result: string = await this.api.httpGet(this.partnersUrl);
    return this.jsonSerializer.deserializeObjectArray(result, OcpiPartner);
  }

  async createOcpiPartner(request: CreateOcpiPartnerRequest): Promise<string> {
    return await this.api.httpPost(this.partnersUrl, request);
  }

  async updateOcpiPartner(
    id: string,
    request: UpdateOcpiPartnerRequest
  ): Promise<void> {
    return await this.api.httpPatch(`${this.partnersUrl}/${id}`, request);
  }

  async resetOcpiPartner(id: string): Promise<string> {
    return await this.api.httpPatch(`${this.partnersUrl}/${id}/reset`, {});
  }

  async deleteOcpiPartner(id: string): Promise<void> {
    return await this.api.httpDelete(`${this.partnersUrl}/${id}`);
  }
}
